import { render, staticRenderFns } from "./templates-dynamic-signature.vue?vue&type=template&id=511a23d0&scoped=true&lang=pug"
import script from "./templates-dynamic-signature.vue?vue&type=script&lang=js"
export * from "./templates-dynamic-signature.vue?vue&type=script&lang=js"
import style0 from "./templates-dynamic-signature.vue?vue&type=style&index=0&id=511a23d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a23d0",
  null
  
)

export default component.exports